import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./SDH.css";
import SDHBenefits from "./SDHBenefits";
import SDHFeatures from "./SDHFeatures";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";

// Main component SDH
export default function SDH() {
  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["AI-Driven SolutionData Hub"]}
        bannerbodycopy="Drive digital connectivity and Insights at the edge"
      />

      {/* Overview section of SDH */}
      <SolutionEcosystem title="Architecture" type="SDH" />

      

     


{/* Agribusiness Network (ABN) and SolutionData Hub (SDH) Section */}
      <div className="our-solution mb-5">
        <Container>
          <Row>
            {/* ABN Section */}
        

              <Col md={6}>
              <div className="services-card">
                <h3>SDH APIs</h3>
                <p>
                  The AI-Driven SolutionData Hub empowers seamless digital
                  connectivity and delivers actionable insights at the edge,
                  enhancing performance and decision-making in real-time.
                  
                </p>
               {/*  <button className="me-3">
                  <NavLink to="/SDH" className="text-decoration-none">
                    Explore SDH
                  </NavLink>
                </button> */}
                <button>
                  <NavLink to="/edge-ai-stack" className="text-decoration-none">
                    Explore SDH API
                  </NavLink>
                </button>
              </div>
            </Col>

           { <Col md={6}>
              <div className="services-card mb-3 mb-md-0">
                <h3>SDH Applications</h3>
                <p>
                  SDH APIs enable rapid development of Agentic Applications within the ABN framework, allowing deployment in just a few days. The SDH stack includes pre-packaged applications designed for quick rollout and scalability across agribusiness ecosystems.

These applications are structured into two models:
                </p>
                <button>
                  <NavLink to="/ABN" className="text-decoration-none">
                    Explore ABN
                  </NavLink>
                </button>
                <button className="me-3">
                  <NavLink to="edge-ai-network" className="text-decoration-none">
                    Explore DTN
                  </NavLink>
                </button>
              </div>
            </Col>}
            

            {/* SDH Section */}
          
          </Row>
        </Container>
      </div>


      {/* Features section  */}
      <SDHFeatures />

      {/* Benefits section  */}
      <SDHBenefits />
    </>
  );
}
